import { render, staticRenderFns } from "./look-logistics.vue?vue&type=template&id=55c23e7d&scoped=true"
import script from "./look-logistics.vue?vue&type=script&lang=js"
export * from "./look-logistics.vue?vue&type=script&lang=js"
import style0 from "./look-logistics.vue?vue&type=style&index=0&id=55c23e7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c23e7d",
  null
  
)

export default component.exports